<template>
  <img src="@/assets/my-calendar/arrow-down.svg" alt="arrow-down" class="arrow-down-svg" />
</template>

<script setup>
</script>

<style scoped>
.arrow-down-svg {
  width: 12px;
  height: 12px;
}
</style>
